var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62422 7.5L5.24922 11.875L4.63672 11.2625L8.39922 7.5L4.63672 3.7375L5.24922 3.125L9.62422 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextArrow);
export default __webpack_public_path__ + "static/media/ic-next-arrow.b814b1bcc78bd4c59e9120ae62bce424.svg";
export { ForwardRef as ReactComponent };